import type { ReactNode } from "react";

interface Props {
  posterTitle: ReactNode;
  posterBody: ReactNode;
  step?: number; // 1..4, when set shows the progress cells
  children: ReactNode;
}

export function AuthLayout({ posterTitle, posterBody, step, children }: Props) {
  return (
    <div style={{ display: "grid", gridTemplateColumns: "minmax(340px,0.82fr) minmax(0,1fr)", alignItems: "stretch", minHeight: "100vh" }}>
      <aside
        style={{
          background: "var(--color-accent)",
          color: "var(--color-bg)",
          padding: "44px 40px 40px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <span style={{ fontFamily: "var(--font-heading)", fontWeight: 800, fontSize: 20, letterSpacing: "-0.03em" }}>
          ALEMBIC
        </span>
        <h1
          style={{
            margin: "auto 0 0",
            fontSize: 48,
            lineHeight: 1.05,
            letterSpacing: "-0.03em",
            marginLeft: "-0.058em",
            maxWidth: "20ch",
          }}
        >
          {posterTitle}
        </h1>
        <p style={{ margin: "20px 0 0", maxWidth: "34ch", fontSize: 15.5, lineHeight: 1.6, opacity: 0.9 }}>{posterBody}</p>
        <div style={{ marginTop: "auto", paddingTop: 36 }}>
          {step ? (
            <>
              <div style={{ display: "flex", gap: 2, marginBottom: 16 }}>
                {[1, 2, 3, 4].map((n) => (
                  <div
                    key={n}
                    style={{
                      height: 6,
                      flex: 1,
                      background: n <= step ? "var(--color-bg)" : "color-mix(in srgb, #f3f2f2 32%, transparent)",
                    }}
                  />
                ))}
              </div>
              <p style={{ margin: 0, fontSize: 12, letterSpacing: "0.08em", textTransform: "uppercase", opacity: 0.85 }}>
                Step {step} of 4
              </p>
            </>
          ) : (
            <p style={{ margin: 0, fontSize: 13, lineHeight: 1.6, opacity: 0.85, maxWidth: "36ch" }}>
              Real recipes. Real batches. Nobody here says "to taste" without a number next to it.
            </p>
          )}
        </div>
      </aside>
      <main style={{ padding: "56px 56px 70px", display: "flex", flexDirection: "column", justifyContent: "center", minWidth: 0 }}>
        <div className="form-narrow">{children}</div>
      </main>
    </div>
  );
}
